import { BUNDLES } from '../constants';

export const getSupportedBundles = (loot) => {
  if (loot.repurchaseble) {
    const bundles = [];
    if (loot.supportedBundles?.length) {
      BUNDLES.forEach((bundle) => {
        if (loot.supportedBundles.includes(bundle)) {
          if (
            Number(loot.bundleVariants?.[bundle]?.price) > 0 ||
            bundle === 'x1'
          ) {
            bundles.push(bundle);
          }
        }
      });
      if (bundles.length) {
        return bundles.length > 4 ? bundles.slice(-4) : bundles;
      }
    }
    return BUNDLES.filter((bundle) => {
      if (bundle === 'x2') return false;
      if (bundle === 'x1') return true;
      return Number(loot.bundleVariants?.[bundle]?.price) > 0;
    }).slice(-4);
  }

  return ['x1'];
};
export const isBundleSupported = (loot, bundle) =>
  getSupportedBundles(loot).includes(bundle);

export const getBundleAmounts = (loot) =>
  getSupportedBundles(loot).map((bundle) => Number(bundle.slice(1)));

export default {
  getBundleAmounts,
  getSupportedBundles,
  isBundleSupported,
};
